import { render } from "./KeyboardComponent.vue?vue&type=template&id=1213403e"
import script from "./KeyboardComponent.vue?vue&type=script&lang=js"
export * from "./KeyboardComponent.vue?vue&type=script&lang=js"

import "./KeyboardComponent.vue?vue&type=style&index=0&id=1213403e&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__